import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import { ActeARealiseDetailsTableListeRestApiService } from './acte-a-realise-details-table.liste.rest-api.service';


@Injectable({providedIn: 'root'})
export class ActeARealiseDetailsTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: ActeARealiseDetailsTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    // console.log('data : ', data);
    // console.log('args : ', args);

    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }

  recupererPoursuiteActeAResRealise(data: any) {
    return this.restApi.recupererPoursuiteActeAResRealise(data);
  }
}
